import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import { Component as Form } from "@repoflow/form-schema";
import * as Notify from "@repoflow/form-schema/notify";
import {
  Mutation,
  Button,
  useSectionContext,
} from "@repoflow/components/section";
import { CancellableContent } from "@repoflow/components/content-cancel";
import * as widgets from "widgets/register";
import * as QueriesQL from "queries/section";

// Hoisted out of the component: a config literal is a new object every render,
// and the form's provider rebuilds its widget tree when that identity changes —
// which detaches the control being typed into. See the note in ../section/edit.
const CREATE_FIELDS = {
  "/Public/Section/Create": {
    fields: [
      "sectionId",
      "tags",
    ],
  },
};

export const Sidebar = () => null;

export const Indice = () => <BreadcrumbItem>Create</BreadcrumbItem>;

export const Content = ({
  history,
  match: {
    params: { siteId },
  },
}) => {
  const { base } = useSectionContext();
  const initial = {
    sectionId: "",
    tags: [],
  };

  return (
    <Mutation
      initial={initial}
      target={{ $ref: "/Public/Section/Create" }}
      mutation={QueriesQL.create}
      update={QueriesQL.update({})}
      onMutate={({ handler, state: { values: input } }) => {
        handler({ variables: { siteId, input } });
      }}
      onCompleted={(data) => {
        // `data` directly, not `{ data }`. Section's Mutation forwards Apollo's
        // onCompleted argument as-is, and Apollo passes the data object — so
        // destructuring a `data` key off it yields undefined and the redirect
        // silently falls back to the list, which is exactly the screen this
        // exists to skip.
        //
        // Straight into the editor because a section created here is empty by
        // construction: the form asks for a name and nothing else, so the list
        // would show a row there is no reason to look at and the next click is
        // always the same one.
        const created =
          data && data.viewer.account.sites.get.sections.create;

        history.replace(created ? `${base}/${created.sectionId}/edit` : base);
      }}
      onError={(error) => {
        Notify.error(error.toString());
      }}
    >
      {MutationHandler}
    </Mutation>
  );
};

const MutationHandler = ({ target, state, schema, mutate }) => {
  const { values, setValues } = state;

  const formProps = {
    schema,
    target,
    widgets,
    onSubmit: () => {
      mutate();
    },
    onChange: (values) => {
      setValues(values);
    },
    config: CREATE_FIELDS,
    values,
  };

  return (
    <CancellableContent>
      <Container className="mt-4">
        <Row>
          <Col>
            <Form {...formProps}>
              <Button type="submit">Create</Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </CancellableContent>
  );
};
